import Vue from 'vue';
import styled, { css } from 'vue-styled-components';
import COLORS from '@design/colors.js';
import {
    FLEX_CENTER,
    ABSOLUTE_BOTH_CENTER,
    RespondMobile,
    FlexColumn,
    applyHoverAndPress,
    square,
    border,
    BLUE,
} from '@styles/common.styled';

import {
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_COLUMN_DIV,
} from '@styles/common.styled.component';

import { darken } from 'polished';

import _FloatingAccount from '@components/floatingAccount/FloatingAccount';

import _Button from '@design/components/button/Button';

export const Wrapper = styled('div', {
    expanded: Boolean,
    visible: Boolean,
    height: String | Number,
})`
    ${FLEX_CENTER}
    width: 100%;
    background-color: ${COLORS['blue-100']};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    height: 64px;
    position: fixed;
    z-index: 100;
    top: 0;
    @media screen and (max-width: 1000px) {
        height: 48px;
        top: 0;
        z-index: 9;

        transition-property: transform;
        transition-duration: 0.5s;
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        @keyframes slide-in-top {
            0% {
                transform: translateY(-1000px);
                opacity: 0;
            }
            100% {
                transform: translateY(0);
                opacity: 1;
            }
        }
        @keyframes slide-out-top {
            0% {
                transform: translateY(0);
                opacity: 1;
            }
            100% {
                transform: translateY(-1000px);
                opacity: 0;
            }
        }

        ${({ expanded, height }) =>
            expanded &&
            css`
                height: ${height || '100vh'};
                min-height: 620px;
                z-index: 20;
                flex-direction: column;
                justify-content: flex-start;
                width: 100%;
            `};

        ${({ visible }) =>
            visible
                ? css`
                      animation: slide-in-top 0.3s
                          cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
                  `
                : css`
                      animation: slide-out-top 0.3s
                          cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
                  `};

        /* CSS specific to iOS devices */
        width: calc(
            100vw - constant(safe-area-inset-right) -
                constant(safe-area-inset-left)
        );
        width: calc(
            100vw - env(safe-area-inset-right) - env(safe-area-inset-left)
        );
    }
`;

export const ContentArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    max-width: 1600px;
    @media screen and (max-width: 1000px) {
        flex-wrap: wrap;
        position: relative;
        flex-direction: column;
        height: 100%;
        width: 100%;
        padding: 0 20px;
    }
`;

export const LogoContainer = styled.div`
    display: flex;
    position: relative;
    height: 56px;
    align-items: center;
    @media screen and (max-width: 1000px) {
        width: 100%;
        height: 48px;
    }
`;

export const MobileMenu = styled.img`
    cursor: pointer;
    display: none;
    @media screen and (max-width: 1000px) {
        display: block;
    }
`;

export const LogoImg = styled('img', { customWidth: Number })`
    width: ${({ customWidth }) => (customWidth || 65) + 'px'};
    cursor: pointer;

    @media screen and (max-width: 1000px) {
        ${ABSOLUTE_BOTH_CENTER}
    }
`;

export const DropArea = styled('div', { expanded: Boolean })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    @media screen and (max-width: 1000px) {
        display: none;
        order: 5;
        width: 100%;
        ${({ expanded }) =>
            expanded &&
            css`
                display: flex;
                flex-direction: column;
                align-items: center;
            `}
    }
`;

export const MenuContainer = styled.ul`
    margin: 0 -18px;
    list-style: none;
    display: flex;
    margin-left: 20px;
    @media screen and (max-width: 1000px) {
        width: 100%;
        max-height: calc(100vh - 88px);
        overflow-y: auto;
        margin: 0;
        flex-direction: column;
    }

    a {
        text-decoration: none;
        &:hover,
        &:active {
            text-decoration: none;
        }
    }
`;

export const MenuText = styled('li', { active: Boolean })`
    margin: 0 18px;
    cursor: pointer;
    font-size: 16px;
    color: ${COLORS['gray-40']};
    ${({ active }) =>
        active
            ? css`
                  font-weight: 600;
                  ${applyHoverAndPress(COLORS['gray-5'])}
              `
            : css`
                  font-weight: 500;
                  ${applyHoverAndPress(COLORS['gray-40'])}
              `};

    @media screen and (max-width: 1000px) {
        margin: 0;
        height: 48px;
        width: 100%;
        /* margin-left: -12.5%; */
        ${FLEX_CENTER}

        &:active {
            background-color: ${COLORS['blue-95']};
        }
    }
`;

export const ButtonContainer = styled.div`
    display: flex;

    .dropdown-content {
        padding-top: 4px;
        padding-bottom: 4px;
        ${border(COLORS['gray-30'])};
        box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .dropdown-menu {
        top: 46px;
    }
    .dropdown-item {
        padding: 0;
        transition: background-color 0.2s;
        ${applyHoverAndPress('white', 'background-color')};
    }
    ${RespondMobile`
        .dropdown {
            display: none;
        }
    `};
`;

export const Button = styled(Vue.component('header-buton', _Button))`
    height: 36px;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 600;
    background-color: white;

    &:hover:enabled {
        background-color: ${darken(0.05, 'white')};
    }
    &:active:enabled {
        background-color: ${darken(0.1, 'white')};
    }

    svg {
        fill: ${COLORS['blue-100']};
        &.add-icon {
            margin-right: 8px;
        }
        &.down-icon {
            margin-left: 4px;
        }
    }
    ${RespondMobile`
        height: 48px;
    `};
`;

/* right: header padding */
export const AccountCircle = styled(
    Vue.component('account-btn', _FloatingAccount),
    { expanded: Boolean }
)`
    position: relative;
    margin-left: 16px;
    @media screen and (max-width: 1000px) {
        position: absolute;
        top: 50%;
        right: 20px;
        margin-top: -16px;
        margin-left: 0;
    }

    .accout-icon-circle {
        ${square(36)};
        border: solid 1px;
        box-shadow: 0 0 1px 0px white inset, 0 0 1px 0px white;
        border-radius: 50%;
        font-size: 14px;
        font-weight: 600;
        position: relative;
        top: auto;
        right: auto;
        ${applyHoverAndPress('white', 'border-color')};
        background-color: transparent;

        @media screen and (max-width: 1000px) {
            font-size: 20px !important;
            width: 30px !important;
            height: 30px !important;
        }

        & > span {
            ${applyHoverAndPress('white')};
            background-color: transparent;
            ${square(100, '%')};
        }
    }

    ${({ expanded }) =>
        expanded &&
        css`
            display: none;
        `}
`;

export const NewCampaignContainer = styled('div', { isSelfMake: Boolean })`
    display: flex;
    align-items: center;
    padding: 12px 16px;

    svg {
        fill: ${({ isSelfMake }) => {
            return isSelfMake ? COLORS['gray-100'] : COLORS['blue-60'];
        }};
    }

    span {
        color: ${({ isSelfMake }) => {
            return isSelfMake ? COLORS['gray-100'] : COLORS['blue-60'];
        }};
    }

    @media screen and (max-width: 1000px) {
        width: 100%;
        height: 48px;
        border-radius: 24px;
        ${applyHoverAndPress('white', 'background-color')};
        justify-content: center;
        margin: 6px 0;
    }
`;

export const NewCampaignText = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS['blue-60']};
    margin-left: 8px;
`;

export const NewCampaignContainerMobile = styled.div`
    display: none;
    ${RespondMobile`
        ${FlexColumn}
        margin: -6px 0;
        // position: absolute;
        // top: 500px;
        // left: 0;
        width: 100%;
    `};
`;

export const NewCampaignContainerMobileTitle = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: ${COLORS['gray-50']};
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &::before,
    &::after {
        content: ' ';
        flex: 1;
        height: 1px;
        background-color: ${COLORS['gray-70']};
    }
    &::before {
        margin-right: 8px;
    }
    &::after {
        margin-left: 8px;
    }
`;

export const BetaSign = styled.span`
    position: relative;
    bottom: 5px;
    right: 1px;
    font-size: 12px;
`;

export const Toast = styled('div', { isError: Boolean })`
    top: -1200px;
    width: 100%;
    height: 64px;
    position: fixed;
    background: ${({ isError }) =>
        isError ? COLORS['red-60'] : COLORS['blue-80']};
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    vertical-align: middle;
    color: #fff;
    line-height: 64px;
    opacity: 1;
    z-index: 100;
    top: 0;
    &.above {
        top: 0;
    }
    &.below {
    }
`;

export const Guide = styled(FLEX_VERTICAL_CENTER_DIV)`
    ${applyHoverAndPress(COLORS['blue-80'], 'background-color')};
    border-radius: 18px;
    padding: 0 16px;
    margin-right: 16px;
    cursor: pointer;
`;

export const GuideText = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    margin-left: 9px;
`;

export const ButtonsContainer = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-left: auto;
    height: 36px;

    ${RespondMobile`
        width: 104px;
        margin: 30px auto 52px;
        justify-content: space-between;
        height: 42px;
    `};

    & + & {
        margin-right: 20px;
    }

    .setting-icon-wrapper {
        cursor: pointer;
        margin-left: 12px;

        ${RespondMobile`
            margin: 0;
    `};

        a {
            font-size: 0;
        }

        svg {
            width: 24px;
            height: 24px;
            ${applyHoverAndPress('white', 'fill')};
            transition: background-color 0.2s;
        }
    }
`;

export const SettingTooltipContent = styled(FLEX_VERTICAL_CENTER_DIV)`
    .subs-emoji {
        margin-right: 8px;
        font-size: 14px;
        font-weight: 500;
    }

    .subs-text {
        font-size: 14px;
        font-weight: 500;
        color: white;
    }
`;

export const NewCampaignBtn = styled.div`
    p {
        .add-icon {
            margin-right: 8px;
        }
        .down-icon {
            margin-left: 8px;
        }

        height: 36px;
        padding: 0 16px;
        font-size: 14px;
        border-radius: 24px;
        background-color: #fff;
        display: flex;
        align-items: center;
        font-weight: 600;
        color: ${BLUE(100)};
        margin-bottom: 1px;
        cursor: pointer;
    }
`;
export const CommentArea = styled(FLEX_COLUMN_DIV, { hasUnread: Boolean })`
    margin-right: 24px;
    position: relative;

    ${RespondMobile`
        margin: 0;
    `};

    ${({ hasUnread }) =>
        hasUnread &&
        css`
            &::before {
                content: '';
                width: 6px;
                height: 6px;
                border: solid 1px #a51015;
                background-color: #ea0a0f;
                position: absolute;
                right: -1px;
                top: 2px;
                border-radius: 50%;
            }
        `}

    .comment-icon {
        ${applyHoverAndPress('white', 'fill')};
        width: 24px;
        height: 24px;
    }
`;
